import { ValueOf } from "../type";

export const InventoryKey = {
  InventoryBalance: "INVENTORY_BALANCE",
} as const;

export type InventoryKeyType = ValueOf<typeof InventoryKey>;
